/* eslint-disable */
import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";

import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import LabTestFilterPopup from "./Popup/FilterLabTestPopup";
import { mergeListById } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import SaveLabTestPopup from "components/Common/Popup/SaveLabTestPopup";

const LaboratorySection = ({
  patientObj = null,
  doctorObj = null,
  labTesterObj = null,
  clinicObj = null,
}) => {
  const params = useParams();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [labTestList, setLabTestList] = useState([]); // Renamed

  const [rowSelection, setRowSelection] = useState({});
  const [selectedLabTestIds, setSelectedLabTestIds] = useState([]); // Renamed
  const [selectedLabTestId, setSelectedLabTestId] = useState(null); // Renamed
  const [selectedTagId, setSelectedTagId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  // get all lab tests
  const getAllLabTestsByPatientId = async () => {
    // Renamed
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MEDICAL_TEST +
        `?token=${token}&members=${params.id}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in lab test list------->", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);
      if (response.status) {
        setLabTestList(response.data); // Renamed
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  //function for remove tag from lab test
  const removeTagFromLabTest = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_MEDICAL_TEST;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedLabTestId(null);
      }, 1000);
    }
  };

  // After any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setLabTestList((prevList) => mergeListById(prevList, data)); // Renamed
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllLabTestsByPatientId();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllLabTestsByPatientId();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    if (params.id) {
      getAllLabTestsByPatientId();
    }
  }, [params.id]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveLabTestOffCanvas" // Updated target
            aria-controls="saveLabTestOffCanvas" // Updated target
            onClick={() => {
              setSelectedLabTestId(row.original._id); // Renamed
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Test Name",
        accessorKey: "name",
      },
      {
        header: "Code",
        accessorKey: "code",
      },
      {
        header: "LOINC Code",
        accessorKey: "loinccode",
      },
      {
        header: "Test Type",
        accessorKey: "categoryname",
      },
      // assigned person name
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
          </div>
        ),
      },
      // doctor name
      {
        header: "Doctor Name",
        accessorKey: "doctorname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.doctorname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.doctorimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.doctorimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.doctorname}</span>
            </p>
          </div>
        ),
      },
      // clinic name
      {
        header: "Clinic Name",
        accessorKey: "clinicname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.clinicname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.clinicimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.clinicimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.clinicname}</span>
            </p>
          </div>
        ),
      },
      // lab tester
      {
        header: "Lab Tester Name",
        accessorKey: "providername",
        Cell: ({ row }) => (
          <div
            className={
              row.original.providername === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.providerimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.providerimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.providername}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Order Date",
        accessorKey: "testorderdate",
      },
      {
        header: "Test Date",
        accessorKey: "testcompleteddate",
      },
      {
        header: "Result Date",
        accessorKey: "resultcompleteddate",
      },
      {
        header: "Result",
        accessorKey: "testresult",
      },
      {
        header: "Status",
        accessorKey: "teststatus",
      },
    ],
    [selectedLabTestId, selectedTagId]
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedLabTestIds(selectedIdsArray); // Renamed
    } else {
      setSelectedLabTestIds([]); // Renamed
    }
  }, [rowSelection]);

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <h3 className="mb-3">Laboratory</h3>
          </div>

          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>

            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#labTestFilterOffCanvas"
              aria-controls="labTestFilterOffCanvas"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#saveLabTestOffCanvas"
              aria-controls="saveLabTestOffCanvas"
            >
              Add New
            </Link>
          </div>
        </div>
      </div>
      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={labTestList}
            enableGrouping
            enableRowSelection={false}
            getRowId={(row) => row._id}
            state={{ columnOrder }}
            initialState={{ columnOrder }}
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50,
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      {/* popup and modals */}
      <SaveLabTestPopup // Renamed
        selectedLabTestId={selectedLabTestId} // Renamed
        setSelectedLabTestId={setSelectedLabTestId} // Renamed
        afterActionClose={afterActionClose}
        patientObj={patientObj}
        doctorObj={doctorObj}
        labTesterObj={labTesterObj}
        clinicObj={clinicObj}
        // setShowAlert={setShowAlert}
        // setAlertMessage={setAlertMessage}
        // setMessageType={setMessageType}
      />

      {/* ------- filter popup ------- */}
      <LabTestFilterPopup
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={resetFilterData}
        moduleSlug="labtest"
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        columnOrder={columnOrder}
        //setColumnOrder={setColumnOrder}
      />
    </div>
  );
};

export default LaboratorySection;
